import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Container,
  DropdownButton,
  Dropdown,
  Modal,
  Form,
  Row,
  Col,
  Pagination, // Import Pagination component
} from "react-bootstrap";
import './ItemsDefault.css'; // Import your CSS file for styling
import axios from "axios";
import {FaPlus, FaEdit, FaTrash } from 'react-icons/fa'; // Import delete icon
import { useNavigate } from 'react-router-dom';
import JewelleryForm from "../addItems/JewelleryForm";
import GemstoneForm from "../addItems/GemstoneForm";
import RudrakshForm from "../addItems/RudrakshForm";
import WatchForm from "../addItems/WatchForm";
import { toast } from "react-toastify";

const Items = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is logged in (this is just a placeholder, replace with actual logic)
    const userLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!userLoggedIn) {
      navigate('/');
    }
  }, [navigate]);

  const [inventory, setInventory] = useState([]); // State for inventory data
  const [selectedItemType, setSelectedItemType] = useState("");
  const [isAddingItem, setIsAddingItem] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [filters, setFilters] = useState({
    items: "",
    number: "",
    group: "",
    description: "",
    altcode: "",
    type: "",
    date: "",
  });
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedGemstoneIndex, setSelectedGemstoneIndex] = useState(0); // State for selected gemstone index
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const rowsPerPage = 10; // Number of rows per page

  const apiUrl = 'https://jwapi.infosware-test.in';

  // Function to fetch all data from different routes
  const fetchData = async () => {
    try {
      const jewelleryData = await axios.get(`${apiUrl}/api/jewellery`);
      const gemData = await axios.get(`${apiUrl}/api/gemstone`);
      const rudrakshData = await axios.get(`${apiUrl}/api/rudraksh`);
      const watchData = await axios.get(`${apiUrl}/api/watch`);

      const combinedData = [
        ...jewelleryData.data.map((item) => ({ ...item, type: "Jewellery" })),
        ...gemData.data.map((item) => ({ ...item, type: "Gemstone" })),
        ...rudrakshData.data.map((item) => ({ ...item, type: "Rudraksh" })),
        ...watchData.data.map((item) => ({ ...item, type: "Watch" })),
      ];
      setInventory(combinedData);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to load data. Please try again later.");
    } finally {
      setIsLoading(false); // Stop loading once data is fetched
    }
  };

  useEffect(() => {
    fetchData(); // Fetch data when component mounts
  }, []);

  // Handle form field changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };

  // Filtered data based on form filters
  const filteredData = inventory.filter((row) => {
    return (
      (row.items || "")
        .toLowerCase()
        .includes((filters.items || "").toLowerCase()) &&
      (row.number ? row.number.toString().toLowerCase() : "").includes(
        (filters.number || "").toLowerCase()
      ) &&
      (row.group || "")
        .toLowerCase()
        .includes((filters.group || "").toLowerCase()) &&
      (row.description || "")
        .toLowerCase()
        .includes((filters.description || "").toLowerCase()) &&
      (row.altcode || "")
        .toLowerCase()
        .includes((filters.altcode || "").toLowerCase()) &&
      (row.type || "")
        .toLowerCase()
        .includes((filters.type || "").toLowerCase()) &&
      (row.created_at || "")
        .toLowerCase()
        .includes((filters.date || "").toLowerCase())
    );
  });

  const addEmptyRows = (data, rowCount = 10) => {
    const emptyRow = {
      srno: "",
      items: "",
      number: "",
      group: "",
      description: "",
      altcode: "",
      type: "",
      date: "",
    };

    while (data.length < rowCount) {
      data.push({ ...emptyRow, srno: "" });
    }
    return data;
  };

  const displayedRows = addEmptyRows([...filteredData]);

  // Calculate the displayed rows based on the current page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = displayedRows.slice(indexOfFirstRow, indexOfLastRow);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Render pagination controls
  const renderPagination = () => {
    const totalPages = Math.ceil(displayedRows.length / rowsPerPage);
    return (
      <Pagination>
        <Pagination.Prev
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    );
  };

  const handleShowAddItem = (type) => {
    setSelectedItemType(type);
    setIsAddingItem(true);
  };

  const handleCloseAddItem = () => {
    setIsAddingItem(false);
  };

  const handleItemClick = (row) => {
    setCurrentItem(row);
    setIsEditMode(false);
  };

  const handleModalClose = () => {
    setCurrentItem(null);
    setIsEditMode(false);
  };

  const handleDeletePhoto = async (photo) => {
    if (currentItem) {
      try {
        // Ensure currentItem.photos is an array before applying .filter()
        const photos = Array.isArray(currentItem.photos) ? currentItem.photos : JSON.parse(currentItem.photos || '[]');

        // Delete the photo from the backend
        await axios.delete(`${apiUrl}/api/${currentItem.type.toLowerCase()}/${currentItem.id}/photo`, {
          data: { photo },
        });

        // Update the currentItem's photos locally
        const updatedPhotos = photos.filter((p) => p !== photo);
        setCurrentItem((prevItem) => ({
          ...prevItem,
          photos: updatedPhotos,
        }));

        // Update the inventory state locally
        setInventory((prevInventory) =>
          prevInventory.map((item) =>
            item.id === currentItem.id ? { ...item, photos: updatedPhotos } : item
          )
        );

        toast.success("Photo deleted successfully!");
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error("Photo not found. It may have already been deleted.");
        } else {
          console.error("Error deleting photo:", error);
          toast.error("An error occurred while deleting the photo. Please try again.");
        }
      }
    }
  };

  const renderGemstoneDetails = (gemstones, editable) => {
    const gemstone = gemstones[selectedGemstoneIndex];
    return (
      <div>
        <Row>
          {Object.entries(gemstone).map(([key, value], idx) => (
            <Col md={4} className="mb-2" key={idx}>
              {editable ? (
                <Form.Group>
                  <Form.Label>{key.charAt(0).toUpperCase() + key.slice(1)}</Form.Label>
                  <Form.Control
                    type="text"
                    value={value}
                    onChange={(e) => {
                      const updatedGemstones = [...gemstones];
                      updatedGemstones[selectedGemstoneIndex][key] = e.target.value;
                      setCurrentItem({ ...currentItem, otheritems: JSON.stringify(updatedGemstones) });
                    }}
                  />
                </Form.Group>
              ) : (
                <div>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}
                </div>
              )}
            </Col>
          ))}
        </Row>
      </div>
    );
  };

  const renderDetails = (item, editable = false) => {
    const entries = Object.entries(item).filter(
      ([key]) => key !== "photos" && key !== "type" && key !== "otheritems" && key !== "created_at" // Remove created_at
    );

    // Ensure item.photos is an array
    const photos = Array.isArray(item.photos) ? item.photos : JSON.parse(item.photos || '[]');

    // Ensure item.otheritems is an array
    let otherItems = [];
    try {
      otherItems = Array.isArray(item.otheritems) ? item.otheritems : JSON.parse(item.otheritems || '[]');
    } catch (error) {
      console.error('Error parsing otheritems:', error);
    }

    const handlePhotoUpload = async (e) => {
      const formData = new FormData();
      formData.append('photo', e.target.files[0]);

      try {
        const response = await axios.post(`${apiUrl}/api/${item.type.toLowerCase()}/${item.id}/photo`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        const updatedPhotos = [...photos, response.data.photo];
        setCurrentItem((prev) => ({ ...prev, photos: updatedPhotos }));
        setInventory((prev) =>
          prev.map((invItem) =>
            invItem.id === item.id ? { ...invItem, photos: updatedPhotos } : invItem
          )
        );
      } catch (error) {
        console.error('Error uploading photo:', error);
        toast.error('Failed to upload photo. Please try again.');
      }
    };

    return (
      <>
        <Row>
          <Col md={4} className="mb-2">
            <div>
              <strong>Item Type :</strong> {item.type}
            </div>
          </Col>
        </Row>
        {photos.length > 0 && (
          <Row className="mb-2">
            <Col>
              <div className="photos-container d-flex justify-content-start">
                {photos.map((photo, idx) => (
                  <div key={idx} className="photo-thumbnail-container mr-2">
                    <img
                      src={`${apiUrl}/${photo}`}
                      alt={`Photo ${idx + 1}`}
                      className="photo-thumbnail"
                    />
                    {editable && (
                      <FaTrash
                        className="text-danger"
                        onClick={() => handleDeletePhoto(photo)}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        )}
        {photos.length < 4 && editable && (
          <Row className="mb-2">
            <Col>
              <Form.Group>
                <Form.Label><strong>Upload Photo :</strong></Form.Label>
                <Form.Control type="file" onChange={handlePhotoUpload} />
              </Form.Group>
            </Col>
          </Row>
        )}
        <Row>
          {entries.map(([key, value], index) => (
            <Col md={4} className="mb-2" key={index}>
              {editable ? (
                <Form.Group>
                  <Form.Label>
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={value}
                    onChange={(e) =>
                      setCurrentItem({ ...currentItem, [key]: e.target.value })
                      }
                      disabled={key === "rfidNo"}
                      className={key === "rfidNo" ? "bg-light text-muted" : ""}
                  />
                </Form.Group>
              ) : (
                <div>
                  <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{" "}
                  {key === "created_at" ? new Date(value).toLocaleString() : value}
                </div>
              )}
            </Col>
          ))}
        </Row>
        {otherItems.length > 0 && (
          <div>
            <Row className="align-items-center">
              <Col md={4}>
                <Form.Label className="mt-3"><h5>Select Otheritems :</h5></Form.Label>
              </Col>
              <Col md={4}>
                <Form.Control
                  as="select"
                  className="mt-4 mb-4"
                  value={selectedGemstoneIndex}
                  onChange={(e) => setSelectedGemstoneIndex(Number(e.target.value))}
                >
                  {otherItems.map((item, index) => (
                    <option key={index} value={index}>
                      {item.type ? item.type.charAt(0).toUpperCase() + item.type.slice(1) : ''} {index + 1}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
            {renderGemstoneDetails(otherItems, editable)}
          </div>
        )}
      </>
    );
  };

  const renderModalContent = () => {
    if (!currentItem) return null;

    return isEditMode ? (
      <Form>
        {renderDetails(currentItem, true)}
        <Button variant="primary" className="mt-3 mb-3" onClick={handleSaveEdit}>
          Save
        </Button>
      </Form>
    ) : (
      <>{renderDetails(currentItem)}</>
    );
  };

  // Edit existing item
  const handleEditItem = (row) => {
    setCurrentItem({ ...row }); // Make a copy of the row for editing
    setIsEditMode(true);
  };

  // Save the edited item
  const handleSaveEdit = async () => {
    if (currentItem) {
      try {
        const formData = new FormData();
        Object.keys(currentItem).forEach(key => {
          if (key === 'photos' && Array.isArray(currentItem[key])) {
            currentItem[key].forEach(photo => formData.append('photos', photo));
          } else {
            formData.append(key, currentItem[key]);
          }
        });

        await axios.put(
          `${apiUrl}/api/${currentItem.type.toLowerCase()}/items/${currentItem.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        fetchData();
        toast.success("Item updated successfully!");
        handleModalClose();
      } catch (error) {
        console.error("Error updating item:", error);
      }
    }
  };

  // Delete an item
  const handleDeleteItem = async (row) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${row.items}?`
    );
    if (confirmDelete) {
      try {
        await axios.delete(`${apiUrl}/api/${row.type.toLowerCase()}/${row.id}`);
        fetchData();
        toast.success("Item deleted successfully!");
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };

  const renderTable = (data) => {
    return (
      <div className="itemsTable-container mb-5">
        <Row className="d-flex justify-content-end align-items-center mb-4">
          <Col md="auto">
            {/* Download Excel Template Dropdown */}
            <DropdownButton
              variant="outline-success"
              title="Download Template"
              id="download-template-dropdown"
            >
              <Dropdown.Item
                onClick={() => {
                  window.location.href = `${apiUrl}/api/jewellery/jewellery-template`;
                }}
              >
                Jewellery Template
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  window.location.href = `${apiUrl}/api/gemstone/gemstone-template`;
                }}
              >
                Gemstone Template
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  window.location.href = `${apiUrl}/api/rudraksh/rudraksh-template`;
                }}
              >
                Rudraksh Template
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  window.location.href = `${apiUrl}/api/watch/watch-template`;
                }}
              >
                Watch Template
              </Dropdown.Item>
            </DropdownButton>
          </Col>
          <Col md="auto">
            {/* Upload Excel Dropdown */}
            <DropdownButton
              variant="outline-primary"
              title="Upload Excel"
              id="upload-excel-dropdown"
            >
              <Dropdown.Item onClick={() => navigate(`/uploadexcel/jewellery`)}>
                Upload Jewellery
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate(`/uploadexcel/gemstone`)}>
                Upload Gemstone
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate(`/uploadexcel/rudraksh`)}>
                Upload Rudraksh
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate(`/uploadexcel/watch`)}>
                Upload Watch
              </Dropdown.Item>
            </DropdownButton>
          </Col>
          <Col md="auto">
            {/* Add Item Type Button */}
            <DropdownButton
              variant="primary"
              title={
                <span>
                Types <FaPlus className="ml-5 mx-1" />
                </span>
              }
              onSelect={(eventKey) => handleShowAddItem(eventKey)}
              className="types-button no-caret"
            >
              <Dropdown.Item eventKey="Jewellery">Jewellery</Dropdown.Item>
              <Dropdown.Item eventKey="Gemstone">Gemstone</Dropdown.Item>
              <Dropdown.Item eventKey="Rudraksh">Rudraksh</Dropdown.Item>
              <Dropdown.Item eventKey="Watch">Watch</Dropdown.Item>
            </DropdownButton>
          </Col>
        </Row>

        {/* Table */}
        <Table striped bordered hover responsive className="mb-0">
          <thead className="table-header">
            <tr>
              {[
                "Sr No.",
                "Items",
                "Number",
                "Group",
                "Description",
                "Alt Code",
                "Type",
                "Date",
                "Actions"
              ].map((header, idx) => (
                <th key={idx}>
                  {header}
                  <input
                    type="text"
                    name={header.toLowerCase().replace(/ /g, "")}
                    value={filters[header.toLowerCase().replace(/ /g, "")]}
                    onChange={handleFilterChange}
                    placeholder="Filter"
                    style={{ width: "100%" }}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{indexOfFirstRow + index + 1}</td>
                <td>
                  {row.items ? (
                    <Button
                      variant=" "
                      className="text-primary"
                      onClick={() => handleItemClick(row)}
                    >
                      {row.items}
                    </Button>
                  ) : (
                    <span>-</span>
                  )}
                </td>
                <td>{row.number}</td>
                <td>{row.group}</td>
                <td>{row.description}</td>
                <td>{row.altcode}</td>
                <td>{row.type}</td>
                <td>
                  {row.items
                    ? new Date(row.created_at).toLocaleString("en-GB", {
                      hour12: true,
                    })
                    : ""}
                </td>
                <td>
                  {row.items && (
                    <div className="d-flex align-items-center ">
                      {/* Edit Icon */}
                      <FaEdit
                        className="text-primary mr-3 mx-4"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleEditItem(row)}
                      />
                      {/* Delete Icon */}
                      <FaTrash
                        className="text-danger"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteItem(row)}
                      />
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {renderPagination()}
      </div>
    );
  };

  const renderForm = () => {
    switch (selectedItemType) {
      case "Jewellery":
        return <JewelleryForm handleSave={fetchData} handleClose={handleCloseAddItem} />;
      case "Gemstone":
        return <GemstoneForm handleSave={fetchData} handleClose={handleCloseAddItem} />;
      case "Rudraksh":
        return <RudrakshForm handleSave={fetchData} handleClose={handleCloseAddItem} />;
      case "Watch":
        return <WatchForm handleSave={fetchData} handleClose={handleCloseAddItem} />;
      default:
        return <p>Please select an item type to add.</p>;
    }
  };

  return (
    <Container className="mt-3 pt-5">
      {isLoading ? (
        <div>Loading...</div>
      ) : error ? (
        <div className="text-danger">{error}</div>
      ) : (
        <>
          {isAddingItem ? (
            renderForm()
          ) : (
            <>
              {renderTable(currentRows)}
              <Modal show={!!currentItem} onHide={handleModalClose} size="lg">
                <Modal.Header id="modalheader" closeButton>
                  <Modal.Title>
                    {isEditMode ? "Edit Item" : "Item Details"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body id="modalbody">{renderModalContent()}</Modal.Body>
                <Modal.Footer id="modalheader"></Modal.Footer>
              </Modal>
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default Items;
